import pckg from '../../../package.json'
import React, { useEffect, useState } from 'react'
import { Loader, Message, Button } from 'semantic-ui-react'
import { cleanup } from '../../common'
import { getEnglishText } from '../../dictionary'
import { hideBootSplash } from '../../lib/bootSplash'
import { PowervaultLogo } from '../NavBar/PowervaultLogo'

import './InitialLoader.css'

let timeoutHandle = null
const slightlyTooLongDuration = 8 * 1000
const wayTooLongDuration = 15 * 1000
const failedToLoadDuration = 20 * 1000

function InitialLoader({ loading = true, stage = getEnglishText('loader : stage1') }) {
  const [displayLoader, setDisplayLoader] = useState(true)
  const [takingTooLong, setTakingTooLong] = useState(false)
  const { version } = pckg

  useEffect(() => {
    hideBootSplash()
    timeoutHandle = setTimeout(() => {
      setTakingTooLong('SLIGHTLY_TOO_LONG')
      timeoutHandle = setTimeout(() => {
        setTakingTooLong('WAY_TOO_LONG')
        timeoutHandle = setTimeout(() => {
          setTakingTooLong('FAILED_TO_LOAD')
        }, failedToLoadDuration)
      }, wayTooLongDuration)
    }, slightlyTooLongDuration)
    return () => clearTimeout(timeoutHandle)
  }, [])

  useEffect(() => {
    if (loading) return

    document.body.classList.remove('initial-load')
    setDisplayLoader(false)
  }, [loading])

  function parseTakingTooLong() {
    switch (takingTooLong) {
      case 'SLIGHTLY_TOO_LONG':
        return { text: getEnglishText('loader : taking-longer-than-usual'), class: 'orange' }
      case 'WAY_TOO_LONG':
        return { text: getEnglishText('loader : something-is-wrong'), class: 'red' }
      case 'FAILED_TO_LOAD':
        return { text: getEnglishText('loader : failed-to-load'), class: 'red' }
      default:
        return { text: getEnglishText('loader : loading'), class: null }
    }
  }

  return (
    <div className={`InitialLoader ${displayLoader ? 'active' : 'inactive'}`}>
      <div className="container">
        <PowervaultLogo standalone />
        <span className="sub-header fade-in">{getEnglishText('common : app-title')}</span>
        {takingTooLong === 'FAILED_TO_LOAD' ? (
          <div className="failed-to-load fade-in">
            <Message error>
              <Message.Header>{getEnglishText('loader : failed-to-load')}</Message.Header>
              <Message.Content>
                <br />
                <Button
                  primary
                  icon="chevron right"
                  labelPosition="right"
                  content={getEnglishText('loader : reload-button')}
                  onClick={async () => await cleanup({ clearCache: true, reload: true, initiator: 'InitialLoader' })}
                />
                <p style={{ paddingTop: 10 }}>
                  If the problem persists after trying the button above please{' '}
                  <strong>
                    <a href={`mailto:service@powervault.co.uk?subject=Portal%20failed%20to%20load%20(v${version})`}>email us</a>
                  </strong>
                </p>
              </Message.Content>
            </Message>
          </div>
        ) : (
          <div className="loader-container fade-in-delay">
            <Loader inline active size="small" />
            <small className={`loading-text ${parseTakingTooLong().class}`}>{takingTooLong ? parseTakingTooLong().text : stage}</small>
          </div>
        )}
      </div>
    </div>
  )
}

export { InitialLoader }
